import { FullPageSpin } from '@faceup/ui'
import { DEFAULT_LANGUAGE, languageEnumToBasename } from '@faceup/utils'
import * as Sentry from '@sentry/react'
import { Suspense, useEffect, useState } from 'react'
import { IntlProvider } from 'react-intl'
import AppProviders from './AppProviders'
import translations, { type BaseTranslations } from './locales'
import AppRouter from './Pages/AppRouter'

const App = () => {
  const [messages, setMessages] = useState<BaseTranslations>()

  useEffect(() => {
    const loadMessages = async () => {
      const newMessages = await translations.messages[DEFAULT_LANGUAGE]()
      setMessages(newMessages)
    }
    void loadMessages()
  }, [])

  return (
    <IntlProvider
      locale={languageEnumToBasename(DEFAULT_LANGUAGE)}
      messages={messages?.default}
      onError={() => {
        // Ignore errors
      }}
    >
      <AppProviders>
        <Suspense fallback={<FullPageSpin />}>
          <AppRouter />
        </Suspense>
      </AppProviders>
    </IntlProvider>
  )
}

export default Sentry.withProfiler(App)
